module.exports = {
  mainBackgroundColor: "#5e5ecc",
  mainColor: "white",
  staffList: [
    { name: 'BL'},
    { name: 'Clement'},
    { name: 'Frankie'},
    { name: 'Jason'},
    { name: 'Kel'},
    { name: 'Ace of Wall'},
    { name: '芝'},
    { name: '蜜瓜'},
  ]
}